import { IResponsiveWidthConstraint } from '@faire/web-api--source/indigofair/data/IResponsiveWidthConstraint';
import { Spacing } from '@faire/web-api--source/indigofair/data/Spacing';
import { WidthConstraint } from '@faire/web-api--source/indigofair/data/WidthConstraint';

export namespace IGridStyle {
  /**
   * Return an instance of IGridStyle with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<IGridStyle>): IGridStyle =>
    ({
      ...(partial ?? {}),
    }) as IGridStyle;
}

export interface IGridStyle {
  row_spacing: keyof typeof Spacing | undefined;
  column_spacing: keyof typeof Spacing | undefined;
  /**
   * This property is used on mobile or on web if responsiveHeaderWidth is not provided
   */
  header_width: keyof typeof WidthConstraint | undefined;
  /**
   * This property is used by web to set the width constraint based on the viewport size
   */
  responsive_header_width: IResponsiveWidthConstraint | undefined;
}
